export class ButtonElement extends HTMLElement {
  private modal: HTMLElement | null = null
  private buttonRole: string | null = null
  private parentId: string | null = null

  connectedCallback() {
    this.buttonRole = this.getAttribute('data-modal-role')
    this.parentId = this.getAttribute('data-modal-parent')

    if (this.buttonRole && this.parentId) {
      this.connectToModal()
    }
  }

  private connectToModal() {
    this.modal = document.querySelector(`x-modal[data-id="${this.parentId}"]`)
    if (this.modal) {
      const modalElement = this.modal as any
      const listeners = modalElement.getListeners()
      switch (this.buttonRole) {
        case 'open':
          this.addEventListener('click', listeners.open)
          break
        case 'close':
          this.addEventListener('click', listeners.close)
          break
        case 'toggle':
          this.addEventListener('click', listeners.toggle)
          break
        case 'disable':
          this.addEventListener('click', listeners.disable)
          break
      }
    } else {
      setTimeout(() => this.connectToModal(), 100)
    }
  }

  disconnectedCallback() {
    if (this.modal) {
      const modalElement = this.modal as any
      const listeners = modalElement.getListeners()
      switch (this.buttonRole) {
        case 'open':
          this.removeEventListener('click', listeners.open)
          break
        case 'close':
          this.removeEventListener('click', listeners.close)
          break
        case 'toggle':
          this.removeEventListener('click', listeners.toggle)
          break
        case 'disable':
          this.removeEventListener('click', listeners.disable)
          break
      }
    }
  }
}
